<div
	style="z-index: 9000"
	class="generic-message-component"
	[class.bg-success]="type === 'success'"
	[class.bg-error]="type === 'danger'"
	[class.bg-warning]="type === 'warning'"
	[class.show-message]="showGenericMessage"
	[class.hide-message]="!showGenericMessage"
	[style.padding-left]="getMenuSize()"
>
	<div class="container-emoticon">
		<div class="emojiico-sctruct {{ emote }}">
			<lbca-icon [name]="emote"></lbca-icon>
		</div>
	</div>

	<div class="container-message">
		<ul
			[class.text-font]="type === 'success'"
			[class.text-gray-50]="type === 'danger' || type === 'warning'"
		>
			<ng-content select="[messagePrimary]"></ng-content>
			<ng-content select="[messageSecondary]"></ng-content>
		</ul>
	</div>

	<div class="container-actions">
		<div
			class="btn-icon"
			[class.hover:text-success]="type === 'success'"
			[class.hover:text-error]="type === 'danger'"
			[class.hover:text-warning]="type === 'warning'"
			(click)="closeFeedMessage()"
		>
			<lbca-icon
				name="lucide:x"
				class="inside-icon"
				[class.text-success]="type === 'success'"
				[class.text-error]="type === 'danger'"
				[class.text-warning]="type === 'warning'"
			></lbca-icon>
		</div>
	</div>
</div>
